<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col>
                    <card style="min-width: 720px;">
                        <b-button-toolbar>
                            <b-button-group>
                                <b-button @click="addNewTask" size="sm" variant="primary" pill>{{ $t('button.new') }}</b-button>
                            </b-button-group>   
                        </b-button-toolbar>
                        <ScheduledTaskTable></ScheduledTaskTable>
                    </card>
                </b-col>
                <b-col>
                    <card style="min-width: 360px;">
                        <ScheduledTaskEditor ref="taskEditor"></ScheduledTaskEditor>
                    </card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import ScheduledTaskTable from '@/components/System/ScheduledTasks/ScheduledTaskTable.vue'
import ScheduledTaskEditor from '@/components/System/ScheduledTasks/ScheduledTaskEditor.vue'

export default {
    name: 'ScheduledTasks',
    components: {
        ScheduledTaskTable, ScheduledTaskEditor
    },
    methods: {
        addNewTask: function() {
            this.$refs.taskEditor.newTask();
        }
    }
}
</script>